import React from "react";
import { QueryRenderer } from "@cubejs-client/react";
import { Spin } from "antd";
import cubejsApi from "../../../cubejsApiBQ";

const rankingZonal = ({ resultSet, props }) => {
    if (resultSet.series()[0] === undefined) {
        props.setZonalX("0");
        props.setZonalY(0);
        props.setZonalZ(0);
    } else {
        resultSet.series()[0].series.map((r, index) => {
            props.setZonalX(r.value === null ? 0 : r.value.toFixed(1));
            props.setZonalY(
                resultSet.series()[1].series[index].value === null
                    ? 0
                    : resultSet.series()[1].series[index].value.toFixed(1)
            );
            return props.setZonalZ(
                resultSet.series()[2].series[index].value === null
                    ? 0
                    : resultSet.series()[2].series[index].value
            );
        });
    }

    return null;
};

const renderChart = (Component, props) => ({ resultSet, error }) =>
    (resultSet && <Component resultSet={resultSet} props={props} />) || (
        <Spin />
    );

const RankingZonal = (props) => {
    return (
        <QueryRenderer
            query={{
                renewQuery: true,
                dimensions: [],
                timeDimensions: [],
                measures: [
                    "ResumenCp.promedioEfectividad",
                    "ResumenCp.promedioIntermediarios",
                    "ResumenCp.promedioMonto",
                ],
                filters: [
                    {
                        dimension: "ResumenCp.fechaCorte",
                        operator: "contains",
                        values: props.fecha !== "" ? [props.fecha] : [],
                    },
                    {
                        dimension: "Usuarios.zona",
                        operator: "contains",
                        values: props.zona !== "" ? [props.zona] : [],
                    },
                ],
            }}
            cubejsApi={cubejsApi}
            render={renderChart(rankingZonal, props)}
        />
    );
};

export default RankingZonal;
